(() => {
  const initVideo = (wrap) => {
    if (!wrap || wrap.dataset.heraV80Ready === 'true') return;
    wrap.dataset.heraV80Ready = 'true';
    const video = wrap.querySelector('video');
    if (!video) return;

    const shouldAutoplay = wrap.dataset.autoplay === 'true';
    const shouldLoop = wrap.dataset.loop === 'true';
    const playbackRate = Number(wrap.dataset.playbackRate || 0.5);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let revealRequested = false;
    let mediaLoaded = false;

    video.defaultPlaybackRate = playbackRate;
    video.playbackRate = playbackRate;
    video.loop = shouldLoop;

    const reveal = () => {
      if (revealRequested) return;
      revealRequested = true;
      wrap.classList.add('is-ready');
    };
    const revealDecodedFirstFrame = () => {
      video.currentTime = 0;
      if (shouldAutoplay && !reducedMotion && 'requestVideoFrameCallback' in video) {
        video.requestVideoFrameCallback(reveal);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(reveal));
      }
      if (shouldAutoplay && !reducedMotion) {
        const promise = video.play();
        if (promise) promise.catch(reveal);
      }
    };

    const loadMedia = () => {
      if (mediaLoaded) return;
      mediaLoaded = true;
      const poster = window.matchMedia('(max-width: 749px)').matches
        ? video.dataset.mobilePoster || video.dataset.poster
        : video.dataset.poster;
      if (poster) video.poster = poster;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.preload = 'metadata';
      video.load();
    };

    video.addEventListener('loadeddata', revealDecodedFirstFrame, { once: true });
    video.addEventListener('playing', reveal, { once: true });
    video.addEventListener('pointerdown', loadMedia, { once: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadMedia();
      }, { rootMargin: '400px 0px' });
      observer.observe(wrap);
    } else {
      loadMedia();
    }

    if (video.readyState >= 2) revealDecodedFirstFrame();
  };

  const initPlans = (root) => {
    if (!root || root.dataset.heraPlansReady === 'true') return;
    root.dataset.heraPlansReady = 'true';
    const buttons = [...root.querySelectorAll('[data-hera-billing]')];
    const prices = [...root.querySelectorAll('[data-hera-plan-price]')];
    const billingNotes = [...root.querySelectorAll('[data-hera-plan-billing-note]')];
    const setBilling = (billing) => {
      root.dataset.billing = billing;
      buttons.forEach((button) => {
        const active = button.dataset.heraBilling === billing;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      prices.forEach((price) => {
        if (price.dataset.isFree === 'true') {
          price.textContent = price.dataset.freeLabel || 'Free';
          return;
        }
        const value = price.dataset[billing] || price.dataset.monthly || '0';
        price.textContent = `$${value}`;
      });
      billingNotes.forEach((note) => {
        note.hidden = note.dataset.heraPlanBillingNote !== billing;
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => setBilling(button.dataset.heraBilling)));
    setBilling('monthly');
  };

  const initAll = () => {
    document.querySelectorAll('[data-hera-v78-video]').forEach(initVideo);
    document.querySelectorAll('[data-hera-app-plans]').forEach(initPlans);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
